import { render, staticRenderFns } from "./YoutubeVideoShow.vue?vue&type=template&id=a425d952&scoped=true&"
import script from "./YoutubeVideoShow.vue?vue&type=script&lang=ts&"
export * from "./YoutubeVideoShow.vue?vue&type=script&lang=ts&"
import style0 from "./YoutubeVideoShow.vue?vue&type=style&index=0&id=a425d952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a425d952",
  null
  
)

export default component.exports